import { render, staticRenderFns } from "./custom-product.vue?vue&type=template&id=3ca854de"
import script from "./custom-product.vue?vue&type=script&lang=js"
export * from "./custom-product.vue?vue&type=script&lang=js"
import style0 from "./custom-product.vue?vue&type=style&index=0&id=3ca854de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports